module.exports = __webpack_public_path__ + "static/media/fasttrack1.d4899083.webp";